import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { apiRequest } from "@/lib/api";

export default function AffiliateAttributionCapture() {
  const location = useLocation();
  const navigate = useNavigate();
  const capturedRef = useRef<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const rawRef = params.get("ref")?.trim().toLowerCase() || "";
    if (!rawRef || capturedRef.current === rawRef) {
      return;
    }

    capturedRef.current = rawRef;

    const run = async () => {
      try {
        await apiRequest("/affiliate/attribution/capture", {
          method: "POST",
          auth: false,
          credentials: "include",
          body: {
            trackingCode: rawRef,
          },
        });
        if (import.meta.env.DEV) {
          console.info("[affiliate-attribution] captured", { trackingCode: rawRef, path: location.pathname });
        }
      } catch (error) {
        if (import.meta.env.DEV) {
          console.warn("[affiliate-attribution] capture failed", {
            trackingCode: rawRef,
            path: location.pathname,
            message: error instanceof Error ? error.message : "Unknown attribution error",
          });
        }
        return;
      }

      const nextParams = new URLSearchParams(location.search);
      nextParams.delete("ref");
      const nextSearch = nextParams.toString();
      navigate(
        {
          pathname: location.pathname,
          search: nextSearch ? `?${nextSearch}` : "",
          hash: location.hash,
        },
        { replace: true },
      );
    };

    void run();
  }, [location.hash, location.pathname, location.search, navigate]);

  return null;
}
